import React from "react";
import { useNavigate } from "react-router-dom";
import "../static/Bootcamp.css";

const bootcamps = [
  {
    id: 1,
    title: "Java Full Stack Bootcamp",
    level: "Beginner to Advanced",
    duration: "4 Months",
    price: "₹9,999",
    tag: "🔥 Most Popular"
  },
  {
    id: 2,
    title: "AI & Machine Learning Bootcamp",
    level: "Intermediate",
    duration: "3 Months",
    price: "₹12,999",
    tag: "🚀 Trending"
  },
  {
    id: 3,
    title: "React + Spring Boot Pro",
    level: "Advanced",
    duration: "2 Months",
    price: "₹7,999",
    tag: "💎 Premium"
  }
];

function Bootcamp() {
  const navigate = useNavigate();

  const handleEnroll = (camp) => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");

    if (!isLoggedIn) {
      alert("Please login to enroll 🚀");
      navigate("/login");
    } else {
      navigate("/enroll", { state: { bootcamp: camp } });
    }
  };

  return (
    <div className="bootcamp-wrapper">
      <div className="bootcamp-hero">
        <h1>QAura Tech Bootcamps</h1>
        <p>Upgrade your skills with industry-ready programs</p>
      </div>

      <div className="bootcamp-container">
        {bootcamps.map((camp) => (
          <div className="bootcamp-card" key={camp.id}>
            <span className="bootcamp-tag">{camp.tag}</span>
            <h2>{camp.title}</h2>
            <p><strong>Level:</strong> {camp.level}</p>
            <p><strong>Duration:</strong> {camp.duration}</p>
            <p className="price">{camp.price}</p>

            <button
              className="enroll-btn"
              onClick={() => handleEnroll(camp)}
            >
              Enroll Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Bootcamp;